import { Directive, Injector, Optional } from '@angular/core';

import {
  DISPLAY_TYPE,
  IWidgetConfig,
  StylableComponent,
  provideAsWidgetRef,
  Parent,
  register,
  styler,
  APPLY_STYLES_TYPE
} from "@wm/components-base";

const DEFAULT_CLS = 'app-tile';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-tile',
  hostClass: DEFAULT_CLS
};

@Directive({
  selector: '[wmTile]',
  providers: [
  provideAsWidgetRef(TileDirective)
  ],
  standalone: true,
  exportAs: 'wmTile'
})
export class TileDirective extends StylableComponent {
  static initializeProps = register('wm-tile');

  constructor(inj: Injector, @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this,APPLY_STYLES_TYPE.CONTAINER);
  }

}

